import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from '../components/messages';

// Providing Callback-Interface for App-API
window.appIsUsingCallback = false;
window.AppApiCallbackListener = {   //App expects presence of global object
    appendCallback(callback) {
        window.appIsUsingCallback = true;
        MessageBroker.subscribe(Messages.WISHLIST.ITEM_DELETED, callback);
        MessageBroker.subscribe(Messages.WISHLIST.ITEM_ADDED, callback);
        MessageBroker.subscribe(Messages.CART.ITEM_ADD_SUCCESS, callback);
        MessageBroker.subscribe(Messages.CART.ITEM_CHANGE_SUCCESS, callback);
    }
};
